/* eslint-disable no-unused-vars */
const en = {
  web_url: 'www.voltshare.co.uk',
  top_title: 'For live charging status use our app',
  app: 'Use app',
  allright:'© 2024 VoltShare Ltd. All rights reserved.',
  home: {
    title: 'Destination EV Charging',
    charger_location: 'YOU ARE CHARGING AT',
    charger_id: 'CHARGER ID',
    email: 'EMAIL',
    call: 'CALL',
    payment_method: 'AVAILABLE PAYMENT METHODS',
    power: 'Power',
    status: 'Status',
    connect: 'Connector',
    price: 'Price per kWh',
    parking: 'Parking',
    min_fee: 'Min. Session Fee',
    vat: '(incl. VAT)',
    continue: 'Continue',
  },
  check: {
    title: 'How to start charging',
    tip: 'This is a Pay per kWh charger. No balance credit or subscription required.'
  },
  success: {
    title: 'Thanks for charging at VoltShare'
  },
  error: {
    title: 'We are sorry, your session was unsuccessful',
    tip: 'There was a problem starting a charge, please try again. Your payment card has not been charged'
  },
  process: {
    title: 'YOUR SESSION IS STARTING…',
    content: 'Please wait while we ensure the connection is stable',
    tip: 'This can take up to 3 minutes. Please do not leave or refresh this screen until you are brought to a confirmation screen.'
  }
}
export default en
